const aws = require("aws-sdk");
const lambda = new aws.Lambda();

/**
 * Function to invoke system capabilities using AWS Lambda.
 * @param {Object} params The parameters to pass to the Lambda function
 * @returns {Promise}
 */
export function invokeSystemCapabilities(params) {
	return lambda
		.invoke({
			FunctionName: "SystemCapabilities",
			Payload: JSON.stringify(params),
		})
		.promise();
};

export class Contact {
	constructor(user) {
		this.user = user;
	}

	/**
	 * Fetches the added contacts for the user
	 * @returns {Promise<Array>} List of contacts
	 */
	async getAddedContacts() {
		const params = {
			capability: "GetData",
			collection: "People",
			query: [{ operand: "userId", value: this.user.userId, operator: "eq" }],
			fields: "contacts",
			sync: true,
		};

		try {
			const data = await invokeSystemCapabilities(params);
			const parsed = JSON.parse(data.Payload);
			const items = parsed?.items?.[0];
			return items?.contacts || [];
		} catch (err) {
			console.error("Error fetching contacts:", err);
			return [];
		}
	}

	/**
	 * Get specified fields for contacts based on UUIDs
	 * @param {Array<string>} uuidArr Array of user IDs
	 * @param {string} field Field to fetch from contacts
	 * @returns {Promise<Array>} List of field values or full contacts
	 */
	async getContactFieldForUUIDs(uuidArr = [], field) {
		try {
			const contacts = await this.getAddedContacts();
			const filteredContacts = contacts.filter(contact =>
				uuidArr.includes(contact.userId)
			);
			return field ? filteredContacts.map(contact => contact[field]) : filteredContacts;
		} catch (err) {
			console.error("Error filtering contacts:", err);
			throw err;
		}
	}

	/**
	 * Placeholder function to add contacts (not implemented)
	 * @param {Array} contacts Contacts to add
	 * @returns {Promise}
	 */
	async addContacts(contacts) {
		// Implement your logic to add contacts
		return;
	}

	/**
	 * Placeholder function to ignore a contact (not implemented)
	 * @param {Object} contact The contact to ignore
	 * @returns {Promise}
	 */
	async ignoreContact(contact) {
		// Implement your logic to ignore a contact
		return;
	}

	/**
	 * Saves contacts (including the ignored ones) to the database
	 * @param {Array} contacts Contacts to save
	 * @param {boolean} ignored Whether to save as ignored
	 * @returns {Promise}
	 */
	async saveContacts(contacts, ignored = false) {
		const document = ignored ? { ignored: contacts } : { contacts };
		const params = {
			capability: "WriteData",
			collection: "People",
			documents: [{
				key: { userId: this.user.userId },
				document,
			}],
			sync: true,
		};

		try {
			const result = await invokeSystemCapabilities(params);
			console.log("Saved contacts:", result);
			return result;
		} catch (err) {
			console.error("Error saving contacts:", err);
			throw err;
		}
	}
};
